import RenderContent from './RenderContent';

export default RenderContent;
